export default __webpack_public_path__ + "bf4d4f25e545c29722d2ab3143ad22e4.wasm";